import {
  NavInputAndLink,
  NavSubTitle,
  NavTitle,
  NavTitles,
  NavWrapper
} from "./navigations.styled";
import {IconButton, InputAdornment} from "@mui/material";
import {SearchIcon} from "../../assets/svg/searchIcon";
import React, {useEffect, useState} from "react";
import {FileParams} from "../../page/dashboard/dashboard";
import {Profile} from "../profile";
import {UiGradientInput} from "../ui/includes/GradientInput";
import {color} from "../../theme/includes/color";
import {ClearIcon} from "../../assets/svg/clearIcon";

interface NavigationsProps {
  setFileParams?: React.Dispatch<React.SetStateAction<FileParams>>;
  totalFiles?: number
}

export function Navigations({setFileParams, totalFiles}: NavigationsProps) {
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    const handler = setTimeout(() => {
      if (setFileParams) {
        setFileParams(fileParams => ({
          ...fileParams,
          search: searchTerm,
          page: 1,
        }))
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [searchTerm, setFileParams])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value)
  }

  return (
    <NavWrapper>
      <NavTitles>
        <NavTitle>Edge Drive</NavTitle>
        <NavSubTitle>{totalFiles ? totalFiles : 'No'} {totalFiles === 1 ? 'file' : 'files'}</NavSubTitle>
      </NavTitles>
      <NavInputAndLink>
        <UiGradientInput
          borderRadius="48px"
          boxShadow="#ffffff"
          sx={{
            maxWidth: '213px',
            borderRadius: '48px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: color('white-100'),
              borderRadius: '48px',
              padding: '0 16px 0 4px',
            },
            '& .MuiOutlinedInput-input': {
              padding: '12.5px 16px 12px 2px',
              borderRadius: '48px',
            }
          }}
          value={searchTerm}
          onChange={handleChange}
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon/>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {searchTerm && (
                  <IconButton
                    aria-label="clear"
                    onClick={() => setSearchTerm('')}
                    edge="end"
                  >
                    <ClearIcon/>
                  </IconButton>
                )}

              </InputAdornment>
            ),
          }}
        />
        <Profile/>
      </NavInputAndLink>
    </NavWrapper>
  )
}
